import { useEffect, useState, useCallback } from "react";
import { Search } from "lucide-react";
import { toast } from "sonner";
import api, { fmtDate, errMsg } from "../../lib/api";
import { PageHeader, StatusBadge, TableShell, TR, TD, LoadingRows, EmptyState } from "../../components/Shared";
import { Input } from "../../components/ui/input";

export default function AdminWebsites() {
  const [sites, setSites] = useState(null);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");

  const load = useCallback(() => {
    api.get("/admin/websites", { params: { q, status } }).then((r) => setSites(r.data));
  }, [q, status]);
  useEffect(() => { load(); }, [load]);

  const toggle = async (w) => {
    try {
      await api.patch(`/admin/websites/${w.id}`, { status: w.status === "active" ? "suspended" : "active" });
      toast.success(`Website ${w.status === "active" ? "suspended" : "activated"}`);
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div data-testid="admin-websites">
      <PageHeader title="Websites" subtitle="Every tenant website across all partners." />
      <div className="flex flex-wrap gap-3 mb-6">
        <div className="relative max-w-sm flex-1 min-w-52">
          <Search className="h-4 w-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input data-testid="website-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search websites…" className="pl-10 h-11 rounded-full" />
        </div>
        <div className="flex gap-2">
          {["", "active", "suspended"].map((s) => (
            <button key={s} data-testid={`filter-${s || "all"}`} onClick={() => setStatus(s)}
              className={`px-4 h-11 rounded-full text-sm font-bold border transition-colors ${status === s ? "bg-primary text-primary-foreground border-transparent" : "border-border hover:border-foreground/40"}`}>
              {s || "All"}
            </button>
          ))}
        </div>
      </div>

      {!sites ? <LoadingRows /> : sites.length === 0 ? <EmptyState title="No websites" body="No websites match your filters." /> : (
        <TableShell testid="websites-table" head={["Website", "Partner", "Type", "Orders", "Created", "Status", "Action"]}>
          {sites.map((w) => (
            <TR key={w.id} testid={`website-row-${w.id}`}>
              <TD><p className="font-bold">{w.name}</p><p className="text-xs text-muted-foreground">/site/{w.slug}</p></TD>
              <TD className="text-sm">{w.partner_name}</TD>
              <TD className="capitalize text-sm">{w.type}</TD>
              <TD className="font-bold">{w.orders_count}</TD>
              <TD className="text-sm text-muted-foreground">{fmtDate(w.created_at)}</TD>
              <TD><StatusBadge status={w.status} /></TD>
              <TD>
                <button data-testid={`website-toggle-${w.id}`} onClick={() => toggle(w)}
                  className={`px-3.5 py-1.5 rounded-full text-xs font-bold border transition-colors ${w.status === "active" ? "border-amber-500/30 text-amber-600 hover:bg-amber-500/10" : "border-emerald-500/30 text-emerald-600 hover:bg-emerald-500/10"}`}>
                  {w.status === "active" ? "Suspend" : "Activate"}
                </button>
              </TD>
            </TR>
          ))}
        </TableShell>
      )}
    </div>
  );
}
